// extracted by mini-css-extract-plugin
module.exports = {"root":"NotesAccordion_root__2AHZB"};